import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';

export const useLogError = () => {
  const [error, setError] = useState<unknown | null>(null);

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development' && error) {
      Sentry.captureException(error);
      setError(null); // Clear the error after reporting
    }
  }, [error]);

  return {
    logError: setError,
    error,
  };
};
